import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {merge} from 'lodash-es';
import {ApiResponse} from "../../../classes/api-response";
import {SnackService} from "../../../services/snack.service";
import {BoxInterfacesService} from "../../../services/box-interfaces.service";
import {BoxInterface} from "../../../model/box-interface";
import {Box} from "../../../model/box";
import {BoxesService} from "../../../services/boxes-service";
import {transformAndValidateSync, TransformValidationOptions} from 'class-transformer-validator';
import {UpdateBoxInterfaceDTO} from 'src/app/model/dto/box-interface/update-box-interface.dto';
import {CreateBoxInterfaceDTO} from 'src/app/model/dto/box-interface/create-box-interface.dto';

@Component({
  selector: 'aw-box-interface-form',
  templateUrl: './box-interface-form.component.html',
  styleUrls: ['./box-interface-form.component.scss']
})
export class BoxInterfaceFormComponent implements OnInit {

  boxInterfaceForm: UntypedFormGroup;
  @Input() creatingFromBox = false;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @Output() boxInterfaceEmitter: EventEmitter<BoxInterface> = new EventEmitter<BoxInterface>();

  saving = false;
  generalError?: ApiResponse;

  boxes: Box[] = [];


  constructor(
    private boxInterfaceService: BoxInterfacesService,
    private boxesService: BoxesService,
    private snackService: SnackService
  ) {



    this.boxInterfaceForm = new UntypedFormGroup(
      {
        name: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        description: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),

      }
    );
  }

  _boxInterface = new BoxInterface();
  isEditing = false;
  loading = false;

  @Input() set boxInterface(value: BoxInterface) {
    this._boxInterface = merge(new BoxInterface(), value);
    this.isEditing = !!value?.id;
    this.boxInterfaceForm.patchValue(this._boxInterface);
  }

  ngOnInit(): void {
    if (!this.isEditing) {
      this.loading = true;
      this.boxesService.getAllBoxes().subscribe(boxes => {
        this.boxes = boxes;
        this.loading = false;
      });
    }
  }

  saveBoxInterface(): void {

    this.saving = true;

    const newBoxInterface = merge(new BoxInterface(), this._boxInterface, this.boxInterfaceForm.value);
    const options : TransformValidationOptions  = {validator: { whitelist: true } };

    this.generalError = undefined;

    if (this._boxInterface.id) {
      const updateBoxInterfaceDTO = transformAndValidateSync(UpdateBoxInterfaceDTO, newBoxInterface,options) as UpdateBoxInterfaceDTO;
      delete newBoxInterface.boxes;
      this.boxInterfaceService.updateBoxInterface(this._boxInterface.id, updateBoxInterfaceDTO)
        .subscribe(
          () => {
            this.saving = false;
            this.boxInterface = newBoxInterface;
            this.snackService.success('Interface updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      const createBoxInterfaceDTO = transformAndValidateSync(CreateBoxInterfaceDTO, newBoxInterface,options) as CreateBoxInterfaceDTO;
      this.boxInterfaceService.createBoxInterface(createBoxInterfaceDTO)
        .subscribe(
          createdBoxInterface => {
            this.saving = false;
            this.boxInterface = createdBoxInterface;
            this.boxInterfaceEmitter.emit(createdBoxInterface);
            this.boxInterface = createdBoxInterface;
            this.snackService.success('Interface created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }


}
